// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clinical-main__scroll:has(.doc-show) {
  display: flex;
  flex-direction: column;
}

.doc-show {
  box-sizing: border-box;
  width: 100%;
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 24px 32px 16px;
}

.doc-show__stack {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
  min-width: 0;
  min-height: 0;
  width: 100%;
  overflow: hidden;
}

.doc-show__top {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 16px;
  border-bottom: 1px solid #F1F5F9;
  margin-bottom: 4px;
}

.doc-show__crumb {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: 16px;
  text-transform: uppercase;
  color: #94A3B8;
}

.doc-show__crumb button {
  border: none;
  padding: 0;
  background: transparent;
  color: #64748B;
  font: inherit;
  cursor: pointer;
}

.doc-show__crumb button:hover {
  color: #0F172A;
}

.doc-show__crumb .is-current {
  color: #0F172A;
  font-weight: 600;
}

.doc-show__hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
}

.doc-show__hero-main {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.doc-show__back {
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  color: #64748B;
  cursor: pointer;
}

.doc-show__back:hover {
  background: #F8FAFC;
  color: #0F172A;
}

[dir='rtl'] .doc-show__back .lucide {
  transform: scaleX(-1);
}

.doc-show__hero-text {
  min-width: 0;
}

.doc-show__title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.doc-show__title-row h1 {
  margin: 0;
  font-size: 20px;
  line-height: 1.25;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0F172A;
}

.doc-show__badge {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 10px;
  border-radius: 9999px;
  border: 1px solid #BAE6FD;
  background: #F0F9FF;
  color: #0369A1;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.doc-show__add {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 32px;
  padding: 0 14px;
  border: 1px solid #0EA5E9;
  border-radius: 8px;
  background: #0EA5E9;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.25);
}

.doc-show__add:hover {
  background: #0284C7;
  border-color: #0284C7;
}

.doc-show__groups {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow: auto;
  padding-inline-end: 4px;
}

.doc-show__group {
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
}

.doc-show__group:hover {
  border-color: #CBD5E1;
}

.doc-show__group-head {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 16px;
  border: none;
  background: rgba(248, 250, 252, 0.7);
  text-align: start;
  font: inherit;
  color: inherit;
  cursor: pointer;
}

.doc-show__group.is-open .doc-show__group-head {
  background: #F8FAFC;
  border-bottom: 1px solid #E2E8F0;
}

.doc-show__identity {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.doc-show__group-id {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 6px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.doc-show__group-id.is-sky {
  background: #E0F2FE;
  color: #0369A1;
}

.doc-show__group-id.is-green {
  background: #CCFBF1;
  color: #115E59;
}

.doc-show__group-id.is-amber {
  background: #FEF3C7;
  color: #92400E;
}

.doc-show__name-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.doc-show__group-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 700;
  color: #1E293B;
}

.doc-show__lines-pill {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 9999px;
  background: rgba(226, 232, 240, 0.7);
  color: #475569;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

.doc-show__aside {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}

.doc-show__paid {
  display: flex;
  align-items: center;
  gap: 8px;
}

.doc-show__paid-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  background: #ffffff;
  white-space: nowrap;
  box-shadow: 0 1px 1px rgba(15, 23, 42, 0.04);
}

.doc-show__paid-item span {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94A3B8;
}

.doc-show__paid-item strong {
  font-size: 12px;
  font-weight: 500;
  color: #334155;
}

.doc-show__split {
  width: 1px;
  height: 20px;
  background: #E2E8F0;
  flex-shrink: 0;
}

.doc-show__chevron {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  color: #475569;
}

.doc-show__group.is-open .doc-show__chevron svg {
  transform: rotate(180deg);
}

.doc-show__table-scroll {
  overflow-x: auto;
}

.doc-show__table {
  width: 100%;
  min-width: 720px;
  border-collapse: collapse;
}

.doc-show__table th {
  padding: 10px 16px;
  background: #F8FAFC;
  color: #64748B;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-align: start;
  text-transform: uppercase;
  white-space: nowrap;
}

.doc-show__table td {
  padding: 12px 16px;
  border-top: 1px solid #F1F5F9;
  color: #334155;
  font-size: 13px;
  vertical-align: middle;
}

.doc-show__table th.is-end,
.doc-show__table td.is-end {
  text-align: end;
}

.doc-show__table th.is-center,
.doc-show__table td.is-center {
  text-align: center;
}

.doc-show__table .is-id {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-weight: 500;
  color: #94A3B8;
  font-variant-numeric: tabular-nums;
}

.doc-show__account {
  font-weight: 500;
  color: #1E293B;
}

.doc-show__table .is-proportion {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-weight: 600;
  color: #0F172A;
  font-variant-numeric: tabular-nums;
}

.doc-show__entry {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.doc-show__entry.is-debit {
  background: #E0F2FE;
  color: #075985;
}

.doc-show__entry.is-credit {
  background: #D1FAE5;
  color: #065F46;
}

.doc-show__empty {
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  background: #ffffff;
}

.doc-show__empty.is-inset {
  border: none;
  border-top: 1px solid #E2E8F0;
  border-radius: 0;
}

.doc-show__summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px 24px;
  flex-shrink: 0;
  margin-top: auto;
  padding: 16px;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  background: #F8FAFC;
}

.doc-show__summary-lead {
  display: flex;
  align-items: center;
  gap: 24px;
  min-width: 0;
}

.doc-show__summary-rule {
  width: 1px;
  height: 28px;
  background: #E2E8F0;
  flex-shrink: 0;
}

.doc-show__summary-scope {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  color: #64748B;
}

.doc-show__summary-weights {
  display: flex;
  align-items: center;
  gap: 32px;
  margin-inline-start: auto;
  text-align: end;
}

.doc-show__summary-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #94A3B8;
}

.doc-show__summary-value {
  margin-top: 2px;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
}

.doc-show__summary-figure {
  margin-top: 2px;
  font-size: 16px;
  font-weight: 700;
  color: #0F172A;
  font-variant-numeric: tabular-nums;
}

.doc-show__balance {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 8px;
  border: 1px solid #FDE68A;
  background: #FFFBEB;
  color: #92400E;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.doc-show__balance.is-balanced {
  border-color: #A7F3D0;
  background: #ECFDF5;
  color: #065F46;
}

@media (max-width: 720px) {
  .doc-show {
    padding: 16px;
  }

  .doc-show__hero {
    grid-template-columns: 1fr;
  }

  .doc-show__group-head,
  .doc-show__aside,
  .doc-show__paid,
  .doc-show__summary,
  .doc-show__summary-lead {
    flex-wrap: wrap;
  }

  .doc-show__summary-weights {
    margin-inline-start: 0;
    text-align: start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/accounting/ShowDocument/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,SAAS;EACT,YAAY;EACZ,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,aAAa;EACb,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,2DAA2D;EAC3D,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2DAA2D;EAC3D,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;;;IAKE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;AACF","sourcesContent":[".clinical-main__scroll:has(.doc-show) {\n  display: flex;\n  flex-direction: column;\n}\n\n.doc-show {\n  box-sizing: border-box;\n  width: 100%;\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 24px 32px 16px;\n}\n\n.doc-show__stack {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: 16px;\n  min-width: 0;\n  min-height: 0;\n  width: 100%;\n  overflow: hidden;\n}\n\n.doc-show__top {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #F1F5F9;\n  margin-bottom: 4px;\n}\n\n.doc-show__crumb {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  line-height: 16px;\n  text-transform: uppercase;\n  color: #94A3B8;\n}\n\n.doc-show__crumb button {\n  border: none;\n  padding: 0;\n  background: transparent;\n  color: #64748B;\n  font: inherit;\n  cursor: pointer;\n}\n\n.doc-show__crumb button:hover {\n  color: #0F172A;\n}\n\n.doc-show__crumb .is-current {\n  color: #0F172A;\n  font-weight: 600;\n}\n\n.doc-show__hero {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 16px;\n}\n\n.doc-show__hero-main {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.doc-show__back {\n  box-sizing: border-box;\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #64748B;\n  cursor: pointer;\n}\n\n.doc-show__back:hover {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n[dir='rtl'] .doc-show__back .lucide {\n  transform: scaleX(-1);\n}\n\n.doc-show__hero-text {\n  min-width: 0;\n}\n\n.doc-show__title-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.doc-show__title-row h1 {\n  margin: 0;\n  font-size: 20px;\n  line-height: 1.25;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0F172A;\n}\n\n.doc-show__badge {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  border: 1px solid #BAE6FD;\n  background: #F0F9FF;\n  color: #0369A1;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.doc-show__add {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 14px;\n  border: 1px solid #0EA5E9;\n  border-radius: 8px;\n  background: #0EA5E9;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.25);\n}\n\n.doc-show__add:hover {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.doc-show__groups {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  overflow: auto;\n  padding-inline-end: 4px;\n}\n\n.doc-show__group {\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  background: #ffffff;\n  overflow: hidden;\n}\n\n.doc-show__group:hover {\n  border-color: #CBD5E1;\n}\n\n.doc-show__group-head {\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 12px 16px;\n  border: none;\n  background: rgba(248, 250, 252, 0.7);\n  text-align: start;\n  font: inherit;\n  color: inherit;\n  cursor: pointer;\n}\n\n.doc-show__group.is-open .doc-show__group-head {\n  background: #F8FAFC;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.doc-show__identity {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.doc-show__group-id {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 6px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 12px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.doc-show__group-id.is-sky {\n  background: #E0F2FE;\n  color: #0369A1;\n}\n\n.doc-show__group-id.is-green {\n  background: #CCFBF1;\n  color: #115E59;\n}\n\n.doc-show__group-id.is-amber {\n  background: #FEF3C7;\n  color: #92400E;\n}\n\n.doc-show__name-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.doc-show__group-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 700;\n  color: #1E293B;\n}\n\n.doc-show__lines-pill {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  background: rgba(226, 232, 240, 0.7);\n  color: #475569;\n  font-size: 11px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.doc-show__aside {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-shrink: 0;\n}\n\n.doc-show__paid {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.doc-show__paid-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  background: #ffffff;\n  white-space: nowrap;\n  box-shadow: 0 1px 1px rgba(15, 23, 42, 0.04);\n}\n\n.doc-show__paid-item span {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #94A3B8;\n}\n\n.doc-show__paid-item strong {\n  font-size: 12px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.doc-show__split {\n  width: 1px;\n  height: 20px;\n  background: #E2E8F0;\n  flex-shrink: 0;\n}\n\n.doc-show__chevron {\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #475569;\n}\n\n.doc-show__group.is-open .doc-show__chevron svg {\n  transform: rotate(180deg);\n}\n\n.doc-show__table-scroll {\n  overflow-x: auto;\n}\n\n.doc-show__table {\n  width: 100%;\n  min-width: 720px;\n  border-collapse: collapse;\n}\n\n.doc-show__table th {\n  padding: 10px 16px;\n  background: #F8FAFC;\n  color: #64748B;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-align: start;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.doc-show__table td {\n  padding: 12px 16px;\n  border-top: 1px solid #F1F5F9;\n  color: #334155;\n  font-size: 13px;\n  vertical-align: middle;\n}\n\n.doc-show__table th.is-end,\n.doc-show__table td.is-end {\n  text-align: end;\n}\n\n.doc-show__table th.is-center,\n.doc-show__table td.is-center {\n  text-align: center;\n}\n\n.doc-show__table .is-id {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-weight: 500;\n  color: #94A3B8;\n  font-variant-numeric: tabular-nums;\n}\n\n.doc-show__account {\n  font-weight: 500;\n  color: #1E293B;\n}\n\n.doc-show__table .is-proportion {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-weight: 600;\n  color: #0F172A;\n  font-variant-numeric: tabular-nums;\n}\n\n.doc-show__entry {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.doc-show__entry.is-debit {\n  background: #E0F2FE;\n  color: #075985;\n}\n\n.doc-show__entry.is-credit {\n  background: #D1FAE5;\n  color: #065F46;\n}\n\n.doc-show__empty {\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  background: #ffffff;\n}\n\n.doc-show__empty.is-inset {\n  border: none;\n  border-top: 1px solid #E2E8F0;\n  border-radius: 0;\n}\n\n.doc-show__summary {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px 24px;\n  flex-shrink: 0;\n  margin-top: auto;\n  padding: 16px;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  background: #F8FAFC;\n}\n\n.doc-show__summary-lead {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  min-width: 0;\n}\n\n.doc-show__summary-rule {\n  width: 1px;\n  height: 28px;\n  background: #E2E8F0;\n  flex-shrink: 0;\n}\n\n.doc-show__summary-scope {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  color: #64748B;\n}\n\n.doc-show__summary-weights {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n  margin-inline-start: auto;\n  text-align: end;\n}\n\n.doc-show__summary-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #94A3B8;\n}\n\n.doc-show__summary-value {\n  margin-top: 2px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #334155;\n}\n\n.doc-show__summary-figure {\n  margin-top: 2px;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0F172A;\n  font-variant-numeric: tabular-nums;\n}\n\n.doc-show__balance {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  border-radius: 8px;\n  border: 1px solid #FDE68A;\n  background: #FFFBEB;\n  color: #92400E;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.doc-show__balance.is-balanced {\n  border-color: #A7F3D0;\n  background: #ECFDF5;\n  color: #065F46;\n}\n\n@media (max-width: 720px) {\n  .doc-show {\n    padding: 16px;\n  }\n\n  .doc-show__hero {\n    grid-template-columns: 1fr;\n  }\n\n  .doc-show__group-head,\n  .doc-show__aside,\n  .doc-show__paid,\n  .doc-show__summary,\n  .doc-show__summary-lead {\n    flex-wrap: wrap;\n  }\n\n  .doc-show__summary-weights {\n    margin-inline-start: 0;\n    text-align: start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
